import React, { PureComponent } from 'react';
import { Select } from 'antd';
import PropTypes from 'prop-types';
import withIcd10CmCodes from 'graphql/hocs/emr/withIcd10CmCodes';
import { SELECT_REFETCH_DELAY } from 'core/uiConstants';
import debounce from 'lodash/debounce';

@withIcd10CmCodes
class Icd10CmCodeSelector extends PureComponent {
  static propTypes = {
    excludeKeys: PropTypes.arrayOf(PropTypes.string),
    onChange: PropTypes.func,
    onGetIcd10CmCodes: PropTypes.func.isRequired,
    value: PropTypes.string, // eslint-disable-line react/require-default-props
    subNote: PropTypes.object,
  };

  static defaultProps = {
    excludeKeys: [],
    onChange: () => undefined,
    subNote: null,
  };

  constructor(props) {
    super(props);
    const { subNote } = props;
    let icd10CmCodes = [];
    if (props.subNote && props.subNote.code) {
      icd10CmCodes = [{ code: subNote.code, mediumDescription: subNote.description }];
    }
    this.state = { icd10CmCodes };
  }

  componentDidMount() {
    this.onSearch();
  }

  onSearch = async searchString => {
    const { onGetIcd10CmCodes, excludeKeys = [] } = this.props;
    const variables = {};
    if (searchString) {
      variables.searchString = searchString;
    } else {
      variables.inCodes = ['F32.9', 'F41.9', 'G89.29', 'J18.9', 'K21.9', 'R56.9'];
    }
    if (excludeKeys.length !== 0) {
      variables.ninCodes = excludeKeys;
    }
    const icd10CmCodes = await onGetIcd10CmCodes(variables);
    this.setState({ icd10CmCodes: icd10CmCodes.nodes });
  };

  render() {
    const { onChange, excludeKeys, ...rest } = this.props;
    const { icd10CmCodes } = this.state;

    const options = icd10CmCodes.map(({ mediumDescription, code }) => (
      <Select.Option value={code} key={code}>
        <div id={`cds-option-${code}`}>
          <strong>{code}</strong>
        </div>
        <small>{mediumDescription}</small>
      </Select.Option>
    ));

    return (
      <Select
        filterOption={false}
        optionLabelProp="value"
        onSelect={onChange}
        placeholder="Select ICD-10-CM code..."
        onSearch={debounce(this.onSearch, SELECT_REFETCH_DELAY)}
        showSearch
        {...rest}
      >
        {options}
      </Select>
    );
  }
}

export default Icd10CmCodeSelector;
